import { SET_CURRENT_SETTING } from 'actiontypes/map';

export default function setCurrentSetting(setting) {
  return {
    type: SET_CURRENT_SETTING,
    payload: setting,
  };
}
